import { z } from 'zod';
/**
 * Leaving the camp at once (ADR 0066): a character whose account already
 * finished the introduction asks the tutor to go straight to Havrebourg. The
 * client only asks; the server checks the zone, the distance and the
 * account, gives what the path would have left and sends the character on.
 */
export const TutorSkipMessageSchema = z.object({}).strict();
/** To the newcomer as they come into the camp: whether the tutor offers to send them on. */
export const TutorSkipOfferSchema = z.object({ available: z.boolean() });
export const TUTOR_SKIP_REFUSALS = [
    'invalid',
    /** No other character of the account made it out of the camp. */
    'not-allowed',
    'too-far',
    'bag-full',
];
export const TutorSkipRejectedSchema = z.object({ reason: z.enum(TUTOR_SKIP_REFUSALS) });
//# sourceMappingURL=tutorial.js.map